import { render, staticRenderFns } from "./PositionFormDetailsMobile.vue?vue&type=template&id=ebda9bb2&"
import script from "./PositionFormDetailsMobile.vue?vue&type=script&lang=js&"
export * from "./PositionFormDetailsMobile.vue?vue&type=script&lang=js&"
import style0 from "./PositionFormDetailsMobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports